import React, { memo, useContext } from 'react';
import { CheckIcon } from '@gwc/icons';
import { Trails } from '../slots/Trail';
import { ListItemContext } from './Item';
export const CheckTrail = memo(function CheckTrail() {
    const context = useContext(ListItemContext);
    if (!context) {
        throw new Error('List.CheckTrail should be placed inside ListBoxItem component');
    }
    const { isSelected } = context;
    if (!isSelected)
        return null;
    return (React.createElement(Trails.Icon, null,
        React.createElement(CheckIcon, null)));
});
